export const MAX_DATE_BY_CARRIER = {
    '2C': 13,
    AA: 10,
    AC: 15,
    AI: 45,
    'AF-KL': 13,
    CA: 30, // TODO: Get this number from BA
    MH: 14,
    NZ: 30,
    SK: 17,
    UA: 15,
    UW: 13,
    VS: 14
}
